import React from "react";
import { formatTimestamp } from "@/shared/lib/appHelpers"
import { useCurrentTool } from "@/shared/hooks/useCurrentTool"

function ReportHeader({ 
  report, 
  isDrawer, 
}) {
  const { currentToolFields, generation_name } = useCurrentTool();
  if (isDrawer) return null;

  return (
    <div className={`flex justify-start flex-col sm:flex-row md:gap-4`}>
      <div className="ml-0 mt-[10px] sm:mt-0 text-left">
        <p className="text-black text-[20px] md:block font-SuisseIntlLight font-semibold capitalize	mt-[4px] md:mt-0 break-words">
          {report.fields?.[currentToolFields?.[0].name]}
        </p>
        <p className="text-[#505050] inline-block text-[14px] font-SuisseIntlLight font-normal justify-center">
          {generation_name} {report.row_number}, {formatTimestamp(report.created_at, 'd/m/y')}
        </p>
      </div>
    </div>
  );
}

export default ReportHeader;
